export default "__VITE_ASSET__lJM1YKug__"